export default __webpack_public_path__ + "static/pages_partner_media_publication-c5000a2921f30ed9e6dbf034a7849196.svg";